import React, {FC, useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import queryString from "query-string";
import {IState} from "../../types/state";
import {useRouter} from "next/router";
import cls from "./posts.module.scss"
import Script from "next/script";
import {schemaPost} from "../schemaorg";
import {IPostCatPageProps, IPostData} from "../../types/posts";
import BlockLoader from "../blocks/BlockLoader";
import PostCard from "./PostCard";
import PageHeader from "../shared/PageHeader";
import Pagination from "../shared/Pagination";

const buildQuery = (options: { page: number }) => {
    const params = {page: 0};
    if (options.page !== 1) {
        params.page = options.page;
    }
    return queryString.stringify(params, {encode: false});
}

const PostPage: FC<IPostCatPageProps> = ({
                                             posts,
                                             dbName,
                                             domain,
                                             breadcrumb,
                                             postCategory,
                                             translationsData,
                                             selectedLocale
                                         }) => {
    const router = useRouter();
    const [page, setPage] = useState<number>(posts.current_page);
    const [total, _] = useState<number>(posts.total);
    const schema = schemaPost(dbName, router.asPath, posts.data)
    const prevLocaleCodeRef: { current: string | undefined } = useRef();
    const prevPageRef: { current: number | undefined } = useRef();

    useEffect(() => {
        prevPageRef.current = page;
        prevLocaleCodeRef.current = selectedLocale;
    }, []);

    useEffect(() => {
        if (page > 1) {
            const query = buildQuery({page});
            const location = `${window.location.pathname}${query ? "?" : ""}${query}`;
            window.history.replaceState(null, "", location);
        } else {
            const location = `${window.location.pathname}`;
            window.history.replaceState(null, "", location);
        }
    }, [page]);

    const handlePageChange = (page: number): void => {
        setPage(page);
    };

    if (!posts.data) {
        return <BlockLoader/>;
    }

    const postsList = posts.data.map((post: IPostData) => {
        return (
            <div key={post.id} className={cls.post_list_item}>
                <PostCard
                    post={post}
                    category={postCategory}
                    translationsData={translationsData}
                    date_checked={true}
                    read_more_checked={true}
                />
            </div>
        );
    });

    return (
        <div className="page">
            <Script
                id={schema.name}
                type="application/ld+json"
                dangerouslySetInnerHTML={{__html: JSON.stringify(schema)}}
            />
            <PageHeader dbName={dbName} header="Latest News" breadcrumb={breadcrumb}/>
            <div className="container">
                <div className="row">
                    <h1 className={`${cls.post_page_title} ${cls.category_title}`}>
                        {postCategory.name}
                    </h1>
                    <div
                        dangerouslySetInnerHTML={{__html: postCategory?.description}}
                        className={cls["category-description"]}
                    />
                    <div>
                        {postsList.length ? (
                            <div className="block">
                                <div className={cls.posts_list}>
                                    {postsList}
                                </div>
                                <div className={cls.posts_pagination}>
                                    {postsList && postsList.length < 20 ? (
                                        <></>
                                    ) : (
                                        <Pagination
                                            current={+page}
                                            siblings={2}
                                            total={total}
                                            onPageChange={handlePageChange}
                                        />
                                    )}
                                </div>
                            </div>
                        ) : (
                            <div className={cls["products-view__empty"]}>
                                <div className={cls["products-view__empty-title"]}>
                                    {translationsData.NothingFound}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PostPage;